import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const Footer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    height: 8rem;

    background-color: ${Colors.primary[100]}; 
`;

export const InfoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 1rem 1.5rem;
    gap: 1rem;

    color: ${Colors.commons.white};
`;

export const VerticalLine = styled.div`
  width: 2px;               /* Espessura da linha */
  height: 100px;            /* Altura da linha */
  background-color: ${Colors.commons.white}; 
`;

export const LogoZandona = styled.img`
    height: 5rem;
    width: auto;
`;

export const TextZandona = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 0.65rem;

    p {
        margin: 0;
    }
`;

export const LocationImg = styled.img`
    height: 5rem;
    width: 6.5rem;
    background-color: green;
    border: 4px solid darkgreen;
`;

export const RightColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const AddressText = styled.h4`
    color: ${Colors.commons.white}; 
    font-weight: normal;
    border-bottom: 2px solid ${Colors.commons.white};
    padding-bottom: 0.25rem;
    margin: 0;
`;

export const LogoElemental = styled.img`
    height: 3rem;
    width: auto;
    margin-top: 0.5rem;
`;

export const ElementalWrapper = styled.div`
    display: flex;
    align-items: center;
`;
